import { useTranslation } from 'react-i18next';

import { CelebrationType } from '../types';

export const useCelebrationDisplay = (
	celebrationType: CelebrationType,
	celebrationDate?: string // original event date (for anniversary year calculation)
) => {
	const { t } = useTranslation('celebrations');

	let emoji = '';
	let text = '';

	const anniversaryNumber =
		celebrationType === CelebrationType.Anniversary && celebrationDate ? new Date().getFullYear() - new Date(celebrationDate).getFullYear() : 0;

	switch (celebrationType) {
		case CelebrationType.Anniversary:
			emoji = '🎉';
			text = `${t('user_popover.anniversary', { anniversaryNumber })}`;
			break;
		case CelebrationType.Birthday:
			emoji = '🎈';
			text = `${t('user_popover.birthday')}`;
			break;
		case CelebrationType.Welcome:
			emoji = '👋';
			text = `${t('user_popover.welcome')}`;
			break;
		default:
			break;
	}

	return {
		emoji,
		text,
	};
};
